import React, { useEffect, useState, useRef } from "react";
import { nodeViewProps } from "@/types/extension-types";
import { classNamePrefix } from "@/utils/common";
import "./index.less";

const getHeadContent = (width) => {
  return `
      <meta name="referrer" content="no-referrer">
      <style type="text/css">
        html {
          max-width: ${width};
        }
        h1, h2, h3, h4, h5, h6, p {
          word-break: break-word
        }
        img {
          max-width: 100%;
        }
        :root body img {
          box-shadow: unset;
        }
      </style>
    `;
};

export const IframeView: React.FC<
  nodeViewProps & {
    htmlContent: string;
    handleClick?: (e) => any;
    handleDoubleClick?: (e) => any;
    handleKeyDown?: (e) => any;
  }
> = (props) => {
  const iframeRef = useRef(null);
  const [iframeId] = useState(Math.random());
  const {
    provider,
    attrs: { content },
    htmlContent,
    type,
    handleClick,
    handleDoubleClick,
    handleKeyDown,
  } = props;

  function sendMsg(msg) {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(JSON.stringify(msg), "*");
    }
  }

  const iframeUrl = provider.getIframeUrl();

  const messageHandler = ({ data, origin }) => {
    if (!document.body.contains(iframeRef.current)) {
      return;
    }
    if (origin !== iframeUrl.origin) return;
    const evt = JSON.parse(data);
    if (iframeId !== evt.id) return;
    switch (evt.type) {
      case "event:click":
        handleClick?.(JSON.parse(evt.data));
        break;
      case "event:dbclick":
        handleDoubleClick?.(JSON.parse(evt.data));
        break;
      case "event:keydown":
        handleKeyDown?.(JSON.parse(evt.data));
        break;
      case "event:heightchange":
        iframeRef.current.style.height = `${evt.data}px`;
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("message", messageHandler);
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  return (
    <div className={classNamePrefix(`${type}`)}>
      <iframe
        key={content}
        ref={iframeRef}
        title="ct-frame"
        className={classNamePrefix("frame")}
        sandbox="allow-scripts allow-same-origin allow-popups"
        src={iframeUrl.href}
        onLoad={() => {
          sendMsg({ op: "setId", data: iframeId });
          if (!content || content.length === 0) return;
          const pageWrapper =
            document.querySelector(".pm-body-wrapper") ||
            document.querySelector(".ProseMirror");
          let width = null;
          if (pageWrapper) {
            const style = window.getComputedStyle(pageWrapper);
            width = `${
              parseFloat(style.width) -
              parseFloat(style.paddingLeft) -
              parseFloat(style.paddingRight) -
              2
            }px`;
          }
          sendMsg({
            op: "insert",
            targetSelector: "head",
            data: getHeadContent(width),
          });
          sendMsg({ op: "insert", data: htmlContent });
          if (type !== "html") {
            sendMsg({
              op: "insert",
              targetSelector: "head",
              data: `
                <link rel="stylesheet" href="//s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/a11y-light.min.css" />
                <link rel="stylesheet" href="//s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/markdown.v4.css" />
              `,
            });
          }
        }}
      />
    </div>
  );
};
